import dayjs from "dayjs";
import { useEffect, useState } from "react";
import MESSAGES from "../../../../common/data/constants/messages";
import { IWorkResource } from "../../../../common/data/dtos/work-resource";
import WorkResourceEnum from "../../../../common/data/enums/enumWorkResouce";
import Badge from "../../../../components/bootstrap/Badge";
import Button from "../../../../components/bootstrap/Button";
import Card, { CardActions, CardBody, CardHeader, CardLabel, CardTitle } from "../../../../components/bootstrap/Card";
import { MoreActions } from "../../../../components/extras/MoreActions";
import { showSuccess, showWarning } from "../../../../components/extras/Notifications";
import PaginationButtons, { dataPagination, PER_COUNT } from "../../../../components/PaginationButtons";
import workResourceService from "../../../../services/work-resource-service";
import LoadingPage from "../../loading/LoadingPage";
import { WorkResourceModal } from "./WorkResourceModal";

export const CommonWorkResourceList = () => {

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(PER_COUNT['10']);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isModalOpened, setIsModalOpened] = useState(false);

    const [workResources, setWorkResources] = useState<IWorkResource[]>([]);
    const [selectedWorkResource, setSelectedWorkResource] = useState<IWorkResource | null>(null);

    useEffect(() => {
        fetchWorkResources();
    }, []);

    const fetchWorkResources = async () => {
		setIsLoading(true);

		const response = await workResourceService.getWorkResources();

		setIsLoading(false);

		if (response.error) {
			showWarning(response.error);
			return;
		}

		setWorkResources(response.workResources || []);
	};

	const toggleModal = (isVisible: boolean) => {
		setIsModalOpened(isVisible);
	};

	const handleAddClick = () => {
		toggleModal(true);
	};

	const onModalClose = () => {
		toggleModal(false);
		setSelectedWorkResource(null);
	};

	const onAfterSubmit = async () => {
		await fetchWorkResources();
		onModalClose();
	};

	const handleDeleteClick = async (workResource: IWorkResource) => {
		if (!workResource.id) {
			showWarning(MESSAGES.ACTION.DELETE_ID_ERROR);
			return;
		}

		setIsLoading(true);

		const response = await workResourceService.deleteWorkResource(workResource.id);

		setIsLoading(false);

		if (response.error) {
			showWarning(response.error);
			return;
		}

		showSuccess(MESSAGES.ACTION.DELETED);
		await fetchWorkResources();
	};

	const handleEditClick = (workResource: IWorkResource) => {
		setSelectedWorkResource(workResource);
		toggleModal(true);
	};

	if (isLoading) {
		return <LoadingPage />;
	}

    return(
        <>
			<Card style={{ minHeight: 600 }}>
				<CardHeader borderSize={1}>
					<CardLabel icon='Build' iconColor='primary'>
						<CardTitle tag='div' className='h5'>
							Ferramentas e EPI
						</CardTitle>
					</CardLabel>
					<CardActions>
						<Button color='light' icon='AddCircle' onClick={handleAddClick}>
							Adicionar
						</Button>
					</CardActions>
				</CardHeader>
				<CardBody className='table-responsive'>
					<table className='table table-modern table-hover'>
						<thead>
							<tr>
								<th>Descrição</th>
								<th>Vencimento</th>
                                <th>CA</th>
                                <th>Tipo</th>
								<th>Situação</th>
								<td aria-labelledby='Actions' />
							</tr>
						</thead>
						<tbody>
							{dataPagination(workResources, currentPage, perPage).map((item: IWorkResource) => (
								<tr key={item.id}>
									<td>{item.description}</td>
									<td>{item.dueDate ? dayjs(item.dueDate).format('DD/MM/YYYY') : '-'}</td>
                                    <td>{item.approvalCertificate}</td>
                                    <td>
										{item.type === WorkResourceEnum.tool ? (
											<h5>
												<Badge color='info' className='align-items-center justify-content-center'>
													Ferramenta
												</Badge>
											</h5>
										) : (
											<h5>
												<Badge color='info' className='align-items-center justify-content-center'>
													EPI
												</Badge>
											</h5>
										)}
									</td>
									<td>
										{item.status ? (
											<h5>
												<Badge color='success' className='align-items-center justify-content-center'>
													Ativo
												</Badge>
											</h5>
										) : (
											<h5>
												<Badge color='danger' className='align-items-center justify-content-center'>
													Inativo
												</Badge>
											</h5>
										)}
									</td>

									<MoreActions id={item.id} showEdit={true} showDelete={true} onEditClick={() => handleEditClick(item)} onDeleteClick={() => handleDeleteClick(item)} />
								</tr>
							))}
						</tbody>
					</table>
				</CardBody>
				<PaginationButtons data={workResources} label='items' setCurrentPage={setCurrentPage} currentPage={currentPage} perPage={perPage} setPerPage={setPerPage} />
			</Card>

			<WorkResourceModal isModalOpened={isModalOpened} onModalClose={onModalClose} onAfterSubmit={onAfterSubmit} selectedWorkResource={selectedWorkResource} />
		</>
    );
}